import { render, staticRenderFns } from "./SideTagsDetails.vue?vue&type=template&id=dcfbf4fc&scoped=true&"
import script from "./SideTagsDetails.vue?vue&type=script&lang=js&"
export * from "./SideTagsDetails.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsDetails.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SideTagsDetails.vue?vue&type=style&index=1&id=dcfbf4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfbf4fc",
  null
  
)

export default component.exports